import React from 'react';
import './Implantologia.css';
import logoSalud from '../assets/images/logo-salud.png';
import logoSeremi from '../assets/images/logo-seremi.png';
import { useNavigate } from 'react-router-dom';

const Implantologia = () => {
  const navigate = useNavigate();

  return (
    <section className="implantologia">
      <div className="container">
        <h2>IMPLANTOLOGÍA POR IMPLANTÓLOGOS CERTIFICADOS</h2>
        
        <p className="descripcion_implantologia">
          CAIMA, Centro Avanzado de Implantología Maxilofacial, 
          certifica que tu cirugía de implantes será realizada por un 
          Implantólogo Bucomaxilofacial especialista con formación 
          universitaria, que cuente con su debida inscripción 
          en los registros de la Superintendencia de Salud de Chile y en un 
          pabellón de cirugía menor acreditado por la Seremi de Salud.
        </p>

        <div className="implantologia-buttons">
          <button className="reserva-btn" onClick={() => window.open('https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1', '_blank')}>
            RESERVA TU HORA
          </button>
          <button className="especialista-btn" onClick={() => navigate('/profesionales')}>
            BUSCA A TU ESPECIALISTA
          </button>
        </div>

        <div className="certificaciones">
          <div className="certificacion">
            <img src={logoSalud} alt="Superintendencia de Salud" />
          </div>
          <div className="certificacion">
            <img src='/assets/images/seremi.jpeg' alt="SEREMI de Salud" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Implantologia; 